module.exports = __webpack_public_path__ + "img/app_device.e7e6fef6.svg";